const s = {
  name: "Delivery",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25,2H0V0h27v7h6.4l6.6,5.5V30h-4.1c-0.5,2.3-2.5,4-4.9,4s-4.4-1.7-4.9-4H15.9c-0.5,2.3-2.5,4-4.9,4
			c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c0.1,0,0.3,0,0.4,0c2.2,0.2,4.1,1.8,4.5,4h10.2c0.4-2.2,2.3-3.8,4.5-4c0.1,0,0.3,0,0.4,0
			c0.1,0,0.2,0,0.3,0c2.3,0.2,4.1,1.8,4.6,4H38v-7h-9V9h-2v15H15v-2h10V2z M31,9v10h7v-5.5L32.6,9H31z M34,28.7
			c-0.1-1.4-1.3-2.6-2.8-2.7c-0.1,0-0.2,0-0.2,0c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C34,28.9,34,28.8,34,28.7z M8,29
			c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3C9.3,26,8,27.3,8,29z"/>
		<path class="st0" d="M21,9.3H5v-2h16V9.3z"/>
		<path class="st0" d="M10,16.7h11v-2H10V16.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Delivery
};
